module.exports = __webpack_public_path__ + "static/media/1.a13a5549.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16018/1.jpg
// module id = 510
// module chunks = 0